export default __webpack_public_path__ + "static/media/aritro.9e24caee.bin";